import { createFileRoute } from '@tanstack/react-router'
import { CompanyDeletePage } from '@/features/companies/delete'

export const Route = createFileRoute('/companies_/$companyId/delete')({
  component: RouteComponent,
})

function RouteComponent() {
  const { companyId } = Route.useParams()
  return <CompanyDeletePage companyId={companyId} />
}
